module.exports = __webpack_public_path__ + "img/V11.95817988.jpg";